import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import AlertBox from 'Components/Common/AlertBox';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import ReportingTabs from 'Components/Reporting/ReportingTabs';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    height: '100%',
  },
}));

const ReportingLayout: FC<RouteComponentProps & { children: React.ReactNode }> = (
  { children, location },
) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ReportingTabs location={location}>
        {children}
      </ReportingTabs>
      <AlertBox />
    </div>
  );
};

export default ReportingLayout;
